module.exports = __webpack_public_path__ + "img/電気回路_1_1_5.445e104a.png";